/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const ADD_CALL_LOG_URL = `${API_URL}/customercallLognew`;
export const GET_EMPLOYEE_LOGS = `${API_URL}/customercallLognew/getEmployeeLogs`;
export const FETCH_CALL_LOGS_URL = `${API_URL}/customercallLognew`;
export const UPDATE_CALL_LOGS_URL = `${API_URL}/customercallLognew/log`;
export const FETCH_CALL_LOG_ANALYTICS = `${API_URL}/customercallLognew/callLogsSummary
`;
